import { intl } from './intl';

export const { t: commonT, Message: CommonMessage } = intl.createMessages({
    create: {
        ru: 'Создать',
        en: 'Create',
    },
    delete: {
        ru: 'Удалить',
        en: 'Delete',
    },
    cancel: {
        ru: 'Отменить',
        en: 'Cancel',
    },
    upload: {
        ru: 'Загрузить',
        en: 'Upload',
    },
    edit: {
        ru: 'Редактировать',
        en: 'Edit',
    },
    editAction: {
        ru: 'Сохранить',
        en: 'Save',
    },
    select: {
        ru: 'Выбрать',
        en: 'Select',
    },
    stopUpload: {
        ru: 'Остановить загрузку',
        en: 'Stop upload',
    },
    uploadAll: {
        ru: 'Загрузить все ({count})',
        en: 'Upload all ({count})',
    },
    file: {
        ru: 'Файл',
        en: 'File',
    },
    chooseFile: {
        ru: 'Выберите файл',
        en: 'Choose file',
    },
    chooseFiles: {
        ru: 'Выберите файл(ы)',
        en: 'Choose file(s)',
    },
    requiredField: {
        ru: '*',
        en: '*',
    },
    emailNotifications: {
        ru: 'Получать оповещения о готовности видео по почте',
        en: 'Receive email notifications when video is ready',
    },
    copyVsid: {
        ru: 'Скопировать vsid в буфер обмена',
        en: 'Copy vsid to clipboard',
    },
    copiedToClipboard: {
        ru: 'Скопировано в буфер обмена',
        en: 'Copied to clipboard',
    },
    language: {
        ru: 'Язык интерфейса',
        en: 'Interface language',
    },
    russian: {
        ru: 'Русский',
        en: 'Russian',
    },
    english: {
        ru: 'Английский',
        en: 'English',
    },
    russianShort: {
        ru: 'RU',
        en: 'RU',
    },
    englishShort: {
        ru: 'EN',
        en: 'EN',
    },
});
